import React, { useState } from "react";
import { Helmet } from "react-helmet";

const ImageGalleryStatic = () => {
  const [selectedTab, setSelectedTab] = useState("images");
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [currentGallery, setCurrentGallery] = useState(null);
  
  const womensDayImages = [
    { src: "assets/images/gallery/womensday/1.jpg", alt: "Women's Day celebration at Columbiaa Hospital, Kasturi Nagar - Empowering women in healthcare" },
    { src: "assets/images/gallery/womensday/2.jpg", alt: "Women's Day event at Columbiaa Hospital - Honoring women doctors and staff" },
    { src: "assets/images/gallery/womensday/3.jpg", alt: "Women's Day celebration Columbiaa Hospital Bangalore - Women in medicine" },
    { src: "assets/images/gallery/womensday/4.jpg", alt: "International Women's Day Columbiaa Hospital - Female healthcare professionals" },
    { src: "assets/images/gallery/womensday/5.jpg", alt: "Women's Day programme at Columbiaa Hospital, Kasturi Nagar" },
    { src: "assets/images/gallery/womensday/6.jpg", alt: "Women's Day celebrations Columbiaa Hospital Bangalore - Women empowerment" },
    { src: "assets/images/gallery/womensday/7.jpg", alt: "Women's Day event Columbiaa Hospital - Recognizing women in healthcare" },
    { src: "assets/images/gallery/womensday/8.jpg", alt: "Women's Day celebration at Columbiaa Hospital - Women doctors and nurses" },
    { src: "assets/images/gallery/womensday/9.jpg", alt: "International Women's Day Columbiaa Kasturi Nagar - Women health champions" },
    { src: "assets/images/gallery/prizes/1.jpg", alt: "Prize distribution ceremony at Columbiaa Hospital - Recognizing excellence" },
    { src: "assets/images/gallery/prizes/2.jpg", alt: "Award ceremony Columbiaa Hospital - Celebrating achievements" },
    { src: "assets/images/gallery/prizes/5.jpg", alt: "Prize distribution event Columbiaa Hospital Bangalore" },
    { src: "assets/images/gallery/prizes/4.jpg", alt: "Columbiaa Hospital prize ceremony - Honoring staff achievements" },
  ];

  const collegeCampImages = [
    { src: "assets/images/gallery/collegecamp/1.jpg", alt: "Health camp at college by Columbiaa Hospital - Student health checkup" },
    { src: "assets/images/gallery/collegecamp/2.jpg", alt: "College health camp Columbiaa Hospital - Medical screening for students" },
    { src: "assets/images/gallery/collegecamp/3.jpg", alt: "Columbiaa Hospital college camp - Health awareness programme" },
    { src: "assets/images/gallery/collegecamp/4.jpg", alt: "Health checkup camp at college Columbiaa Bangalore" },
    { src: "assets/images/gallery/collegecamp/5.jpg", alt: "College medical camp Columbiaa Hospital - Youth health initiatives" },
    { src: "assets/images/gallery/collegecamp/8.jpg", alt: "College health camp Columbiaa Kasturi Nagar - Community outreach" },
  ];

  const purpleDayImages = [
    { src: "assets/images/gallery/purpleday/1.png", alt: "World Purple Day celebration at Columbiaa Hospital - Epilepsy awareness" },
    { src: "assets/images/gallery/purpleday/2.png", alt: "Purple Day Columbiaa Hospital - Spreading epilepsy awareness" },
    { src: "assets/images/gallery/purpleday/3.jpg", alt: "Epilepsy awareness day Columbiaa Hospital - Purple for epilepsy" },
    { src: "assets/images/gallery/purpleday/4.jpg", alt: "Purple Day event at Columbiaa Hospital, Kasturi Nagar" },
    { src: "assets/images/gallery/purpleday/7.jpg", alt: "World Purple Day celebration Columbiaa Bangalore - Neurological awareness" },
    { src: "assets/images/gallery/purpleday/8.jpg", alt: "Purple Day Columbiaa Hospital - Supporting epilepsy patients" },
    { src: "assets/images/gallery/purpleday/5.png", alt: "Columbiaa Hospital Purple Day - Community awareness programme" },
    { src: "assets/images/gallery/purpleday/6.png", alt: "Epilepsy awareness Columbiaa Hospital - Purple day activities" },
    { src: "assets/images/gallery/purpleday/9.png", alt: "World Purple Day at Columbiaa Kasturi Nagar - Raising awareness" },
  ];

  const healthCheckupImages = [
    { src: "assets/images/gallery/healthcheckup/1.jpeg", alt: "Health checkup camp at Columbiaa Hospital - Free medical screening" },
    { src: "assets/images/gallery/healthcheckup/2.jpeg", alt: "Columbiaa Hospital health camp - Preventive healthcare services" },
    { src: "assets/images/gallery/healthcheckup/3.jpeg", alt: "Free health checkup Columbiaa Kasturi Nagar - Community wellness" },
    { src: "assets/images/gallery/healthcheckup/4.jpeg", alt: "Health camp Columbiaa Hospital - Comprehensive medical checkups" },
    { src: "assets/images/gallery/healthcheckup/5.jpeg", alt: "Medical checkup camp at Columbiaa Bangalore - Early detection" },
    { src: "assets/images/gallery/healthcheckup/6.jpeg", alt: "Columbiaa Hospital health checkup - Corporate wellness programme" },
    { src: "assets/images/gallery/healthcheckup/7.jpeg", alt: "Health screening camp Columbiaa Hospital - Community health" },
    { src: "assets/images/gallery/healthcheckup/8.jpeg", alt: "Free health camp Columbiaa Kasturi Nagar - Public health initiative" },
    { src: "assets/images/gallery/healthcheckup/9.jpeg", alt: "Columbiaa Hospital wellness camp - Health awareness and screening" },
  ];
  
  const nuesesdayImages = [
    { src: "assets/images/gallery/nursesday/1.jpeg", alt: "Nurses Day celebration at Columbiaa Hospital - Honoring nursing staff" },
    { src: "assets/images/gallery/nursesday/2.jpeg", alt: "International Nurses Day Columbiaa Hospital - Celebrating nurses" },
    { src: "assets/images/gallery/nursesday/3.jpeg", alt: "Nurses Day event Columbiaa Hospital - Recognizing dedication" },
    { src: "assets/images/gallery/nursesday/4.jpeg", alt: "Nursing excellence award Columbiaa Hospital - Nurses Day" },
    { src: "assets/images/gallery/nursesday/5.jpeg", alt: "Nurses Day celebration at Columbiaa Kasturi Nagar" },
    { src: "assets/images/gallery/nursesday/6.jpeg", alt: "Columbiaa Hospital Nurses Day - Tribute to nurses" },
    { src: "assets/images/gallery/nursesday/7.jpeg", alt: "Nurses appreciation Columbiaa Hospital - Healthcare heroes" },
    { src: "assets/images/gallery/nursesday/8.jpeg", alt: "Nurses Day ceremony Columbiaa Bangalore - Nursing profession" },
    { src: "assets/images/gallery/nursesday/9.jpeg", alt: "Columbiaa Hospital nursing staff - Nurses Day celebration" },
    { src: "assets/images/gallery/nursesday/10.jpeg", alt: "Nurses Day event at Columbiaa Hospital - Compassionate care" },
    { src: "assets/images/gallery/nursesday/11.jpeg", alt: "International Nurses Day Columbiaa Kasturi Nagar - Nurses honored" },
    { src: "assets/images/gallery/nursesday/12.jpeg", alt: "Columbiaa Hospital Nurses Day - Thank you nurses" },
    { src: "assets/images/gallery/nursesday/13.jpeg", alt: "Nurses Day celebration Columbiaa Bangalore - Nursing excellence" },
    { src: "assets/images/gallery/nursesday/14.jpeg", alt: "Nurses Day at Columbiaa Hospital - Healthcare champions" },
    { src: "assets/images/gallery/nursesday/15.jpeg", alt: "Nursing team Columbiaa Hospital - Nurses Day appreciation" },
    { src: "assets/images/gallery/nursesday/16.jpeg", alt: "Nurses Day programme Columbiaa Kasturi Nagar - Honoring nurses" },
  ];

  const neurosurgeonAwardsImages = [
    { src: "assets/images/gallery/neurosurgeonawards/indianmedicalawards.png", alt: "Dr. H.V. Satish Babu - Indian Medical Awards recognition for neurosurgery excellence" },
    { src: "assets/images/gallery/neurosurgeonawards/twellmagazine.png", alt: "Dr. H.V. Satish Babu featured in Twell Magazine - Top neurosurgeon recognition" },
    { src: "assets/images/gallery/neurosurgeonawards/healthcaremagazine.png", alt: "Dr. H.V. Satish Babu featured in Healthcare Magazine - Leading neurosurgeon in Bangalore" },
    { src: "assets/images/gallery/neurosurgeonawards/cioprime.png", alt: "Dr. H.V. Satish Babu - CIO Prime recognition for healthcare leadership" },
    { src: "assets/images/gallery/neurosurgeonawards/Businessmanmagazine.png", alt: "Dr. H.V. Satish Babu featured in Businessman Magazine - Excellence in neurosurgery" },
    { src: "assets/images/gallery/neurosurgeonawards/asiabusinessoutlook.png", alt: "Dr. H.V. Satish Babu - Asia Business Outlook recognition for medical excellence" },
  ];

  const msmeVisitImages = [
    { src: "assets/images/gallery/MSMEvisit/gallery36.jpg", alt: "MSME India delegates visit Columbiaa Hospital, Kasturi Nagar - Delegates arrival" },
    { src: "assets/images/gallery/MSMEvisit/gallery37.jpg", alt: "MSME India delegates visit Columbiaa Hospital, Kasturi Nagar - Delegates group photo" },
    { src: "assets/images/gallery/MSMEvisit/gallery38.jpg", alt: "MSME India delegates visit Columbiaa Hospital, Kasturi Nagar - Hospital tour" },
    { src: "assets/images/gallery/MSMEvisit/gallery39.jpg", alt: "MSME India delegates visit Columbiaa Hospital, Kasturi Nagar - Interaction with doctors" },
  ];

  const icuRoundsImages = [
    { src: "assets/images/gallery/ICUrounds/gallery51.jpg", alt: "Dr. H.V. Satish Babu during ICU rounds at Columbiaa Hospital - Assessing patients" },
    { src: "assets/images/gallery/ICUrounds/gallery52.jpg", alt: "Dr. H.V. Satish Babu guiding critical care team during ICU rounds" },
    { src: "assets/images/gallery/ICUrounds/gallery53.jpg", alt: "Dr. H.V. Satish Babu Neurosurgeon reviewing patient condition in ICU" },
    { src: "assets/images/gallery/ICUrounds/gallery54.jpg", alt: "Dr. H.V. Satish Babu discussing patient care with critical care team" },
    { src: "assets/images/gallery/ICUrounds/gallery55.jpg", alt: "Dr. H.V. Satish Babu during patient assessment in ICU Columbiaa Hospital" },
    { src: "assets/images/gallery/ICUrounds/gallery56.jpg", alt: "Dr. H.V. Satish Babu leading ICU rounds at Columbiaa Hospital, Kasturi Nagar" },
    { src: "assets/images/gallery/ICUrounds/gallery57.jpg", alt: "Dr. H.V. Satish Babu monitoring patient progress in ICU" },
  ];

  const kmaVisitImages = [
    { src: "assets/images/gallery/karnatakameiteiassociationvisit/kma1.png", alt: "Karnataka Meitei Association (KMA) team visit Columbiaa Hospital, Kasturi Nagar - Team arrival" },
    { src: "assets/images/gallery/karnatakameiteiassociationvisit/kma2.png", alt: "Karnataka Meitei Association (KMA) team visit Columbiaa Hospital, Kasturi Nagar - Group photo" },
    { src: "assets/images/gallery/karnatakameiteiassociationvisit/kma3.png", alt: "Karnataka Meitei Association (KMA) team visit Columbiaa Hospital, Kasturi Nagar - Hospital tour" },
    { src: "assets/images/gallery/karnatakameiteiassociationvisit/kma4.png", alt: "Karnataka Meitei Association (KMA) team visit Columbiaa Hospital, Kasturi Nagar - Interaction with doctors" },
    { src: "assets/images/gallery/karnatakameiteiassociationvisit/kma5.png", alt: "Karnataka Meitei Association (KMA) team visit Columbiaa Hospital, Kasturi Nagar - Facility visit" },
  ];

  const ariahAestheticsImages = [
    { src: "assets/images/gallery/ariahaesthestics/ariah2.png", alt: "Dr. H.V. Satish Babu participating in the Opening Ceremony of ARIAH Aesthetics, Bengaluru" },
    { src: "assets/images/gallery/ariahaesthestics/ariah3.png", alt: "Opening Ceremony of ARIAH Aesthetics - Dr. H.V. Satish Babu with dignitaries" },
    { src: "assets/images/gallery/ariahaesthestics/ariah4.png", alt: "ARIAH Aesthetics Grand Opening - Dr. H.V. Satish Babu inaugurating the event" },
    { src: "assets/images/gallery/ariahaesthestics/ariah5.png", alt: "Dr. H.V. Satish Babu at ARIAH Aesthetics Opening Ceremony, Bengaluru" },
    { src: "assets/images/gallery/ariahaesthestics/ariah6.png", alt: "ARIAH Aesthetics Launch Event - Dr. H.V. Satish Babu with the team" },
  ];

  const continuingNursingEducationImages = [
    { src: "assets/images/gallery/continousnursingeducation/gallery22.jpg", alt: "Continuous Nursing Education Program at Columbiaa Hospital, Kasturi Nagar - Session in progress" },
    { src: "assets/images/gallery/continousnursingeducation/gallery23.jpg", alt: "Nursing education programme Columbiaa Hospital - Excellence in patient care training" },
    { src: "assets/images/gallery/continousnursingeducation/gallery24.jpg", alt: "Continuous Nursing Education for excellence in patient care at Columbiaa Hospital" },
    { src: "assets/images/gallery/continousnursingeducation/gallery25.jpg", alt: "Nursing professionals at Columbiaa Hospital attending continuing education programme" },
    { src: "assets/images/gallery/continousnursingeducation/gallery26.png", alt: "Glimpses of Continuous Nursing Education Program at Columbiaa Hospital, Kasturi Nagar" },
    { src: "assets/images/gallery/continousnursingeducation/gallery27.png", alt: "Excellence in patient care - Nursing education at Columbiaa Hospital Bangalore" },
  ];

  const doctorsDayImages = [
    { src: "assets/images/gallery/doctorsday/gallery12.jpg", alt: "National Doctors' Day celebration at Columbiaa Hospital, Kasturi Nagar - Doctors honored" },
    { src: "assets/images/gallery/doctorsday/gallery13.jpg", alt: "Doctors' Day celebrations Columbiaa Hospital - Recognizing medical professionals" },
    { src: "assets/images/gallery/doctorsday/gallery14.jpg", alt: "National Doctors' Day Columbiaa Hospital Bangalore - Saluting our saviours" },
    { src: "assets/images/gallery/doctorsday/gallery15.jpg", alt: "Doctors' Day event at Columbiaa Hospital - Celebrating healthcare heroes" },
    { src: "assets/images/gallery/doctorsday/gallery16.jpg", alt: "Columbiaa Hospital Doctors' Day celebration - Honoring doctors and staff" },
  ];

  const neuroOutreachImages = [
    { src: "assets/images/gallery/neurooutreach/gallery58.jpeg", alt: "Neuro Outreach Camp in rural West Bengal - Columbiaa Hospital team arrival" },
    { src: "assets/images/gallery/neurooutreach/gallery59.jpeg", alt: "Neuro Outreach Camp West Bengal - Patient consultation at Columbiaa Hospital" },
    { src: "assets/images/gallery/neurooutreach/gallery60.jpeg", alt: "Columbiaa Hospital Neuro Outreach Camp - Examining patients in rural Bengal" },
    { src: "assets/images/gallery/neurooutreach/gallery69.png", alt: "Neuro Outreach Camp conducted by Columbiaa Hospital in West Bengal" },
    { src: "assets/images/gallery/neurooutreach/gallery77.jpeg", alt: "Columbiaa Hospital neurosurgery team at West Bengal Outreach Camp" },
    { src: "assets/images/gallery/neurooutreach/98.jpeg", alt: "Neuro Outreach Camp - Dr. H.V. Satish Babu with patients in West Bengal" },
    { src: "assets/images/gallery/neurooutreach/99.jpeg", alt: "Columbiaa Hospital rural healthcare initiative - Neuro Camp in West Bengal" },
    { src: "assets/images/gallery/neurooutreach/100.jpeg", alt: "Neuro Outreach Camp - Patient screening at Columbiaa Hospital, Bengal" },
    { src: "assets/images/gallery/neurooutreach/101.jpeg", alt: "Columbiaa Hospital team conducting Neuro Outreach Camp in West Bengal" },
    { src: "assets/images/gallery/neurooutreach/102.jpeg", alt: "Neuro Outreach Camp - Columbiaa Hospital serving rural communities" },
    { src: "assets/images/gallery/neurooutreach/103.jpeg", alt: "Glimpses of Neuro Outreach Camps in rural West Bengal by Columbiaa Hospital" },
  ];

  const top10NeurosurgeonsImages = [
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/top10neurosurgeon.jpeg", alt: "Dr. H.V. Satish Babu recognised among the Top 10 Neurosurgeons in India – 2025 by Asia Business Outlook" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery66.jpg", alt: "Glimpses of Dr H V Satish Babu being recognised among the Top 10 Neurosurgeons in India – 2025" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery67.jpg", alt: "Dr. H.V. Satish Babu - Asia Business Outlook Top 10 Neurosurgeons in India 2025" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery78.jpg", alt: "Top 10 Neurosurgeons in India 2025 - Dr. H.V. Satish Babu recognition by Asia Business Outlook" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery79.jpg", alt: "Dr H V Satish Babu Among Top 10 Neurosurgeons in India - Asia Business Outlook 2025" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery80.jpg", alt: "Asia Business Outlook recognises Dr. H.V. Satish Babu among Top 10 Neurosurgeons in India 2025" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery81.jpg", alt: "Glimpses of Dr H V Satish Babu receiving Top 10 Neurosurgeons in India recognition" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery82.jpg", alt: "Dr. H.V. Satish Babu - Top 10 Neurosurgeons in India 2025 by Asia Business Outlook" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery83.jpg", alt: "Top 10 Neurosurgeons in India 2025 award recognition for Dr. H.V. Satish Babu" },
    { src: "assets/images/gallery/drhvsatishbabutop10neurosurgeons/gallery84.jpg", alt: "Dr H V Satish Babu being felicitated among Top 10 Neurosurgeons in India - Asia Business Outlook 2025" },
  ];

  const christmasCelebrationsImages = [
    { src: "assets/images/gallery/christmascelebrations/95.jpg", alt: "Christmas celebrations at Columbiaa Hospital, Kasturi Nagar - festive decorations" },
    { src: "assets/images/gallery/christmascelebrations/96.jpg", alt: "Colleagues celebrating Christmas at Columbiaa Hospital" },
    { src: "assets/images/gallery/christmascelebrations/97.jpg", alt: "Christmas festivities at Columbiaa Hospital, Kasturi Nagar" },
  ];

  const rajeshYlVisitImages = [
    { src: "assets/images/gallery/rajeshyl/89.jpg", alt: "Honoured to welcome Rajesh Y L to Columbiaa Hospital, Kasturi Nagar - Deputy Superintendent of Police, Bengaluru" },
    { src: "assets/images/gallery/rajeshyl/90.jpg", alt: "Rajesh Y L, Deputy Superintendent of Police, Bengaluru visits Columbiaa Hospital, Kasturi Nagar" },
    { src: "assets/images/gallery/rajeshyl/91.jpg", alt: "Glimpses of Rajesh Y L's visit to Columbiaa Hospital, Kasturi Nagar - DSP Bengaluru" },
  ];

  const videos = [
    {
  title: "Mega Health Check-up Camp | Participant Testimonials | Columbiaaa Hospital",
  description: "Watch heartfelt testimonials from participants of the Mega Health Check-up Camp organised by Columbiaaa Hospital, Bengaluru. Their words of appreciation reflect the hospital's commitment to providing accessible, compassionate, and quality healthcare to the community. These inspiring experiences highlight the importance of preventive health check-ups, early diagnosis, and patient-centred care in improving overall well-being.",
  url: "https://www.youtube.com/embed/BrySIuwh2Rs"
},
    {
  title: "Smoking & Alcohol – Small Habits, Big Health Risks | Columbiaa Hospital",
  description: "Smoking and excessive alcohol consumption can silently harm your health over time, increasing the risk of high blood pressure, heart disease, stroke, diabetes, liver disease, lung disorders, and several types of cancer. In this awareness video, Columbiaa Hospital highlights the long-term impact of these habits and the importance of adopting a healthier lifestyle. Quitting smoking, limiting alcohol intake, exercising regularly, and undergoing routine health check-ups can significantly improve your overall well-being and quality of life.",
  url: "https://www.youtube.com/embed/1VY08igNiKY"
},
    {
  title: "Advanced Cardiothoracic & Vascular Care | Prof. Dr. Durga Prasad Reddy B | Columbiaa Hospital",
  description: "Meet Prof. Dr. Durga Prasad Reddy B, Head of the Department and Consultant Cardiothoracic & Vascular Surgeon at Columbiaa Hospital, Bengaluru. With over 30 years of surgical expertise, he specialises in advanced heart and vascular care, offering comprehensive diagnosis and treatment for complex cardiac and vascular conditions. Discover how Columbiaa Hospital combines experienced specialists, advanced technology, and patient-centred care to deliver trusted cardiovascular treatment.",
  url: "https://www.youtube.com/embed/NYxwr_o8Sd4"
},
    {
  title: "Advanced Cardiothoracic & Vascular Care | Dr. Sadruddin Shariff F | Columbiaa Hospital",
  description: "Meet Dr. Sadruddin Shariff F, Consultant Cardiothoracic & Vascular Surgeon at Columbiaa Hospital, Bengaluru. With over 37 years of overall medical experience, including 26 years of specialised expertise, he provides advanced diagnosis and surgical treatment for a wide range of heart and vascular conditions. Learn how Columbiaa Hospital delivers comprehensive cardiothoracic and vascular care through experienced specialists, advanced technology, and compassionate patient-focused treatment.",
  url: "https://www.youtube.com/embed/iPTrJJ_MALg"
},
    {
  title: "Advanced Skin Care at Columbiaa Aesthetics | Columbiaa Hospital",
  description: "Discover advanced skin care solutions at Columbiaa Aesthetics, the dedicated aesthetic medicine department at Columbiaa Hospital, Bengaluru. From personalised skin treatments to advanced dermatological procedures, our expert team is committed to helping you achieve healthy, radiant skin through safe, effective, and customised care using modern technology and evidence-based treatments.",
  url: "https://www.youtube.com/embed/sr-DhlYgnGg"
},
    {
  title: "Refractive Errors Awareness | Dr. Prashant Singh | Columbiaa Hospital",
  description: "Watch Dr. Prashant Singh, Consultant Ophthalmologist at Columbiaa Hospital, Bengaluru, explain refractive errors and the importance of timely eye care. Learn about common vision problems such as myopia (nearsightedness), hyperopia (farsightedness), and astigmatism, their symptoms, causes, and available treatment options. Early diagnosis and appropriate vision correction can help maintain clear eyesight and improve quality of life.",
  url: "https://www.youtube.com/embed/dcaaNUpTR3I"
},
    {
  title: "Columbiaa Dental & Implants Centre | Dr. Claudia Dayanandini | Columbiaa Hospital",
  description: "Watch Dr. Claudia Dayanandini, Consultant Endodontist at Columbiaa Dental & Implants Centre, Columbiaa Hospital, Bengaluru, share insights into advanced endodontic care. She specialises in painless root canal treatments with a strong focus on preserving natural teeth using modern techniques and precision-driven treatment. Discover how personalised care, advanced technology, and patient comfort come together to deliver healthy, confident smiles.",
  url: "https://www.youtube.com/embed/UUM1t9IcxsU"
},
    {
  title: "Patients from Kuwait & Arab Countries Visited Columbiaa Hospital | Dr. S. Arivazhagan",
  description: "Watch the inspiring journey of patients from Kuwait and other Arab countries who chose Columbiaa Hospital, Bengaluru, for advanced cardiac treatment. Dr. S. Arivazhagan, Senior Cardio Thoracic & Vascular Surgeon, provided expert heart care backed by international standards, advanced technology, and compassionate treatment. Columbiaa Hospital continues to be a trusted destination for specialised cardiac care for patients from India and around the world.",
  url: "https://www.youtube.com/embed/g62hem21P2Y"
},
    {
  title: "International Nurses Day Wishes 2026 | Dr. Raghunandan S. K. | Columbiaa Hospital",
  description: "Watch Dr. Raghunandan S. K., Consultant Physician & Diabetologist at Columbiaa Hospital, Bengaluru, extend his heartfelt wishes on International Nurses Day 2026. He expresses sincere appreciation to all nurses for their compassion, patience, and unwavering commitment to patient care. Their dedication, support, and selfless service play a vital role in improving the health and well-being of patients and their families every day.",
  url: "https://www.youtube.com/embed/TDRUtj_8Pjs"
},
    {
  title: "International Nurses Day Wishes 2026 | Dr. H. V. Satish Babu | Columbiaa Hospital",
  description: "Watch Dr. H. V. Satish Babu, Medical Director and Head of the Neurosciences Department at Columbiaa Hospital, Bengaluru, extend his heartfelt wishes on International Nurses Day 2026. He expresses sincere appreciation to all nurses for their compassion, dedication, and unwavering commitment to patient care. Their tireless service, support, and professionalism make a meaningful difference in the lives of patients and their families every day.",
  url: "https://www.youtube.com/embed/MgStGC9rpfw"
},
    {
  title: "International Nurses Day Wishes 2026 | Dr. Ashish Mathew | Columbiaa Hospital",
  description: "Watch Dr. Ashish Mathew, Consultant Orthopaedic Surgeon at Columbiaa Hospital, Bengaluru, extend his heartfelt wishes on International Nurses Day 2026. He expresses sincere gratitude to all nurses for their unwavering dedication, compassion, and exceptional patient care. Their commitment, professionalism, and selfless service form the backbone of quality healthcare, making a meaningful difference in the lives of patients every day.",
  url: "https://www.youtube.com/embed/X0XO7hN4BaE"
},
    {
  title: "International Nurses Day Wishes 2026 | Dr. Prashant Singh | Columbiaa Hospital, Bangalore",
  description: "Watch Dr. Prashant Singh, Consultant Ophthalmologist at Columbiaa Hospital, Bangalore, extend heartfelt wishes on the occasion of International Nurses Day 2026. A sincere tribute to the dedication, compassion, and unwavering commitment of nurses, whose care and service make a lasting difference in the lives of patients every day.",
  url: "https://www.youtube.com/embed/-rRJDN3xxcY"
},
    {
  title: "Neck Cracking Sounds: When Is It Normal? | Dr. H. V. Satish Babu | Columbiaa Hospital",
  description: "Watch Dr. H. V. Satish Babu, Medical Director and Head of the Neurosciences Department at Columbiaa Hospital, explain why cracking or creaking sounds in the neck are usually harmless. Learn about the common causes, including gas bubbles in the joint fluid, poor posture, and prolonged desk work, and discover when these sounds may indicate the need for medical evaluation.",
  url: "https://www.youtube.com/embed/utpw2DgliBo"
},
    {
  title: "Lifetime Excellence in Neurosurgery & Brain Care Award | Dr. H. V. Satish Babu | Columbiaa Hospital",
  description: "Watch the proud moments as Dr. H. V. Satish Babu, Medical Director and Head of the Neurosciences Department at Columbiaa Hospital, Bengaluru, receives the prestigious Lifetime Excellence in Neurosurgery & Brain Care Award at the Indian Medical Awards 2026, held on 26th April 2026 in Hyderabad. This honour recognises his decades of outstanding contribution to neurosurgery, brain care, and compassionate patient treatment.",
  url: "https://www.youtube.com/embed/ZJzWCRtmAos"
},
    {
  title: "Epilepsy Care: Importance of Timely Medication | Dr. H. V. Satish Babu | Columbiaa Hospital",
  description: "Watch Dr. H. V. Satish Babu, Medical Director and Head of the Neurosciences Department at Columbiaa Hospital, explain why taking epilepsy medication on time is essential for effective seizure control. Learn how missing doses or stopping treatment without medical advice can increase seizure risk and why consistent medication plays a vital role in improving safety and quality of life.",
  url: "https://www.youtube.com/embed/a4AV3B4Il98"
},
    {
  title: "Burning Feet & Nerve Damage: A Warning Sign of Diabetes | Dr. H. V. Satish Babu | Columbiaa Hospital",
  description: "Watch Dr. H. V. Satish Babu, Medical Director and Head of the Neurosciences Department at Columbiaa Hospital, explain how a burning sensation in the feet can be an early sign of diabetic neuropathy. Learn how high blood sugar and chronic alcohol use can damage nerves, the symptoms to watch for, and why early diagnosis and treatment are essential.",
  url: "https://www.youtube.com/embed/75T0n3BsD5k"
},
    {
  title: "Columbiaa Hospital Collaborates with ARIAH Aesthetics | Grand Inauguration | Bengaluru",
  description: "Watch the grand inauguration of ARIAH Aesthetics, a modern and well-equipped aesthetic clinic, launched in collaboration with Columbiaa Hospital. The clinic was inaugurated on 20th March 2026 at Thanisandra Main Road, R. K. Hegde Nagar, Bengaluru, marking a new milestone in advanced aesthetic and wellness care.",
  url: "https://www.youtube.com/embed/wcZ1TPNDHxE"
},
    {
  title: "Sumana Sadhaka Awards 2026 | Columbiaa Hospital Honoured | Bengaluru Event Highlights",
  description: "Watch the highlights of Columbiaa Hospital receiving the prestigious Sumana Sadhaka Award 2026. Mr. Pavan Kumar R., Managing Director, was honoured by Shri Dinesh Gundu Rao, Hon'ble Minister for Health & Family Welfare, Government of Karnataka, on 28th March 2026 at Jnana Jyothi Auditorium, Bengaluru. This recognition reflects Columbiaa Hospital's commitment to excellence, compassion, and quality healthcare.",
  url: "https://www.youtube.com/embed/WSQazOtCmbg"
},
    {
  title: "Understanding Spine Surgery | Dr. H. V. Satish Babu | Columbiaa Hospital, Bangalore",
  description: "Watch Dr. H. V. Satish Babu, Medical Director and Head of the Neurosciences Department at Columbiaa Hospital, Bangalore, explain spine problems, treatment options, and recovery after spine surgery. This awareness talk also highlights a successful spine surgery performed at Columbiaa Hospital following consultation at the West Bengal Neuro Outreach Camp.",
  url: "https://www.youtube.com/embed/M7vYFl5AkPQ"
},
    {
  title: "How Safe Is Plastic Surgery? | Dr. Madhusudhan V. L. | Columbiaa Hospital, Kasturi Nagar",
  description: "Watch Dr. Madhusudhan V. L., Consultant Plastic and Reconstructive Surgeon at Columbiaa Hospital, Kasturi Nagar, explain how safe modern plastic surgery is and what patients should know before undergoing any procedure.",
  url: "https://www.youtube.com/embed/VFR_kLI7Xv0"
},
    {
  title: "Patient Attendant Testimonial | Dr. H. V. Satish Babu | Columbiaa Hospital, Kasturi Nagar",
  description: "Listen to the heartfelt words of appreciation from a patient attendant whose loved one received expert neurosurgical care under Dr. H. V. Satish Babu, Consultant Neurosurgeon, at Columbiaa Hospital, Kasturi Nagar. A genuine patient experience reflecting trust, compassion, and quality healthcare.",
  url: "https://www.youtube.com/embed/rnvz0owhEOI"
},
    {
      title: "Christmas Message | Dr. H. V. Satish Babu | Columbiaa Hospital, Kasturi Nagar",
      description: "On the occasion of Christmas, Dr. H. V. Satish Babu, Medical Director and Head of the Neurosciences Department at Columbiaa Hospital, shares heartfelt wishes of peace, hope, and good health.",
      url: "https://www.youtube.com/embed/nfKnxfqnHpE"
    },
    {
      title: "Felicitation Ceremony | Dr. H. V. Satish Babu | Top 10 Neurosurgeons in India | Columbiaa Hospital",
      description: "Columbiaa Hospital proudly felicitates Dr. H. V. Satish Babu, Medical Director and Head of the Neurosurgery Department, on being recognised among the Top 10 Neurosurgeons in India.",
      url: "https://www.youtube.com/embed/1DoPotDU2QI"
    },
    {
      title: "Dr. H. V. Satish Babu Ranked Among Top 10 Neurosurgeons in India | Columbiaa Hospital",
      description: "Columbiaa Hospital proudly felicitates Dr. H. V. Satish Babu, Medical Director and Head of Neurosurgery, for being recognised among the Top 10 Neurosurgeons in India.",
      url: "https://www.youtube.com/embed/INqK5xT3Qt0"
    },
    {
      title: "Advanced Brain & Spine Care | Dr. H. V. Satish Babu | Columbiaa Hospital, Kasturi Nagar",
      description: "Columbiaa Hospital, Kasturi Nagar is home to a world-class Neurosciences Department led by Dr. H. V. Satish Babu, Senior Consultant Neurosurgeon.",
      url: "https://www.youtube.com/embed/dQ85NHrUQNY",
    },
    {
      title: "Attender's Gratitude | Dr S. Arivazhagan - Senior Cardio Thoracic Surgeon | Columbiaa Hospital",
      description: "A moment of heartfelt gratitude from a patient's family for the care provided by Dr S. Arivazhagan at Columbiaa Hospital, Kasturi Nagar.",
      url: "https://www.youtube.com/embed/i54MftQC_eM"
    },
    {
      title: "World Internal Medicine Day | Prof Dr G. K. Prakash - Chief Physician | Columbiaa Hospital",
      description: "Join us at Columbiaa Hospital, Kasturi Nagar in marking World Internal Medicine Day with Chief Physician Prof Dr G K Prakash.",
      url: "https://www.youtube.com/embed/Lk0R0ATD5Kw"
    },
    {
      title: "Honouring Our Healthcare Heroes - Columbiaa Hospital, Kasturi Nagar",
      description: "A tribute to the doctors, nurses and staff of Columbiaa Hospital on Doctors' Day 2025.",
      url: "https://www.youtube.com/embed/DeNAhf0lnBw"
    },
    {
      title: "Columbiaa Hospital Moments | Staff Celebration and Team Spirit",
      description: "A joyful glimpse into the vibrant work culture at Columbiaa Hospital, Kasturi Nagar.",
      url: "https://www.youtube.com/embed/3FegNbGLLqU"
    },
    {
      title: "Team Columbiaa in Action | Behind the Scenes at Columbiaa Hospital",
      description: "Catch a quick behind-the-scenes moment at Columbiaa Hospital, Kasturi Nagar.",
      url: "https://www.youtube.com/embed/KMR7_BrebvA"
    },
    {
      title: "Caring Beyond Treatment | Columbiaa Hospital, Kasturi Nagar",
      description: "A short glimpse into the compassionate side of Columbiaa Hospital.",
      url: "https://www.youtube.com/embed/gOHLknD3VcQ"
    },
    {
      title: "Celebrating Health and Hope | Columbiaa Hospital Highlights",
      description: "An uplifting short video from Columbiaa Hospital, Kasturi Nagar showcasing our commitment to good health.",
      url: "https://www.youtube.com/embed/VwIgOT4aMvQ"
    },
    {
      title: "Columbiaa Hospital - A Glimpse Into Care & Compassion",
      description: "A quick short from Columbiaa Hospital, Kasturi Nagar showing how our team goes beyond treatment.",
      url: "https://www.youtube.com/embed/JpHfpT7N6QQ"
    },
    {
      title: "Columbiaa Hospital Highlights - Dedicated Team, Trusted Care",
      description: "A brief snippet featuring the commitment and teamwork at Columbiaa Hospital, Kasturi Nagar.",
      url: "https://www.youtube.com/embed/L4j8cnL0kU0"
    },
    {
      title: "Columbiaa Hospital - Quick Insight into Patient Well-being",
      description: "Watch a short moment from Columbiaa Hospital, Kasturi Nagar emphasising our focus on patient-wellness.",
      url: "https://www.youtube.com/embed/1vwkeK61fxE"
    },
    {
      title: "Columbiaa Hospital - Moments of Healing & Hope",
      description: "A short from Columbiaa Hospital, Kasturi Nagar capturing the spirit of healing and hope.",
      url: "https://www.youtube.com/embed/iHrAHJhBpGs"
    },
    {
      title: "Don't Ignore Migraine | Columbiaa Hospital | Dr. H. V. Satish Babu",
      description: "A message from Dr H. V. Satish Babu, Senior Neurosurgeon at Columbiaa Hospital, Kasturi Nagar about migraine awareness.",
      url: "https://www.youtube.com/embed/bTkb5eCJgtw"
    },
    {
      title: "Why I Chose to Be a Neurosurgeon - Dr. Satish Babu | Columbiaa Hospital",
      description: "In this video, Dr H. V. Satish Babu shares his journey into neurosurgery.",
      url: "https://www.youtube.com/embed/RhtutPbloSo"
    },
    {
      title: "Meet Dr H. V. Satish Babu | Senior Consultant Neurosurgeon | Columbiaa Hospital",
      description: "Get to know Dr H. V. Satish Babu, Medical Director and Senior Consultant Neurosurgeon at Columbiaa Hospital, Kasturi Nagar.",
      url: "https://www.youtube.com/embed/c31y238dko4"
    },
    {
      title: "Columbiaa Hospital - Advanced Medical Services | Bengaluru",
      description: "An overview video of Columbiaa Hospital, Kasturi Nagar's advanced medical services.",
      url: "https://www.youtube.com/embed/_cCPLBCRKxI"
    },
    {
      title: "Discover Advanced Healthcare at Columbiaa Hospital, Bengaluru",
      description: "Experience world-class medical services at Columbiaa Hospital, Kasturi Nagar.",
      url: "https://www.youtube.com/embed/PxGskROCMes",
    },
    {
      title: "Experience Advanced Medical Services at Columbiaa Hospital, Bengaluru",
      description: "Step inside Columbiaa Hospital, Kasturi Nagar for a walkthrough of our clinical excellence.",
      url: "https://www.youtube.com/embed/Qfp8Pcdkt0c",
    },
    {
      title: "Columbiaa Hospital, Kasturi Nagar Inaugurates 24/7 Dialysis Service",
      description: "On 5th August 2025, Columbiaa Hospital, Kasturi Nagar proudly inaugurated its advanced 24/7 Dialysis Centre.",
      url: "https://www.youtube.com/embed/a9UopTCOW5g",
    },
    {
      title: "Understanding Hypertension | Prof. Dr. G. K. Prakash | Columbiaa Hospital, Kasturi Nagar",
      description: "Senior Physician Prof. Dr. G. K. Prakash from Columbiaa Hospital explains hypertension.",
      url: "https://www.youtube.com/embed/WMRpaCK7Heg",
    },
    {
      title: "Words of Appreciation from an Elderly Patient | Columbiaa Hospital, Kasturi Nagar",
      description: "An elderly patient at Columbiaa Hospital shares his heartfelt experience.",
      url: "https://www.youtube.com/embed/IFeX5wdWt0w",
    },
    {
      title: "Bone Mineral Density (BMD) Free Camp Highlights | Columbiaa Hospital, Kasturi Nagar, Bangalore",
      description: "Columbiaa Hospital, Kasturi Nagar successfully organised a Free Bone Mineral Density (BMD) Camp.",
      url: "https://www.youtube.com/embed/6PcSBNijACY",
    },
    {
      title: "Columbiaa Hospital | Advanced Healthcare with Expert Doctors & Specialised Departments, Bengaluru",
      description: "Experience advanced healthcare at Columbiaa Hospital, Bengaluru.",
      url: "https://www.youtube.com/embed/R6yoHuaLDkY",
    },
    {
      title: "Understanding Obesity | Prof. Dr. G. K. Prakash | Columbiaa Hospital, Kasturi Nagar",
      description: "Senior Physician Prof. Dr. G. K. Prakash discusses obesity.",
      url: "https://www.youtube.com/embed/46hZi4JJ370",
    },
    {
      title: "Patient Attender's Words of Appreciation | Columbiaa Hospital, Kasturi Nagar",
      description: "A patient attender shares heartfelt words of appreciation about Columbiaa Hospital.",
      url: "https://www.youtube.com/embed/mk8zdhNIM2s",
    },
    {
      title: "Patient Testimonial | Complex Spine Surgery by Dr. H. V. Satish Babu | Columbiaa Hospital",
      description: "A Bengali patient shares his experience after undergoing complex spine surgery.",
      url: "https://www.youtube.com/embed/ZNjiapTDgI0",
    },
    {
      title: "Words of Appreciation from a Patient | Columbiaa Hospital, Kasturi Nagar",
      description: "A patient shares heartfelt words of appreciation for the compassionate care.",
      url: "https://www.youtube.com/embed/sGohWhWW8kg"
    },
    {
      title: "Free Health Check-Up Camp at Horamavu Lake | Columbiaa Hospital, Kasturi Nagar",
      description: "Columbiaa Hospital conducted a Free Health Check-Up Camp at Horamavu Lake.",
      url: "https://www.youtube.com/embed/oLcYZ32LfVc"
    },
    {
      title: "Patient's Words of Appreciation for Dialysis Care | Columbiaa Hospital, Kasturi Nagar",
      description: "A patient shares heartfelt words of appreciation for the dedicated dialysis care.",
      url: "https://www.youtube.com/embed/F0SGb4HqAJI"
    },
    {
      title: "Free Health Check-Up Camp at Holy Family Church, Ramamurthy Nagar | Columbiaa Hospital",
      description: "Columbiaa Hospital conducted a Free Health Check-Up Camp at Holy Family Church.",
      url: "https://www.youtube.com/embed/CaV2svmaGw8"
    },
    {
      title: "Words of Appreciation | Exceptional Care at Columbiaa Hospital, Kasturi Nagar",
      description: "A patient shares heartfelt words of appreciation for the exceptional care.",
      url: "https://www.youtube.com/embed/SCuqYpkGIlQ"
    },
    {
      title: "Heartfelt Recovery Journey | Columbiaa Hospital, Kasturi Nagar",
      description: "A patient shares their heartfelt story of recovery and care.",
      url: "https://www.youtube.com/embed/2y4mpV3cQb8"
    },
    {
      title: "Patient's Appreciation from West Bengal | Dr. H. V. Satish Babu | Columbiaa Hospital",
      description: "A patient from West Bengal shares heartfelt gratitude after undergoing major surgery.",
      url: "https://www.youtube.com/embed/GOmH7W6dnuE"
    },
    {
      title: "Doctors' Day 2025: Saluting the Saviours in Uniform | Columbiaa Hospital, Kasturi Nagar",
      description: "On Doctor's Day 2025, we salute the saviours in uniform at Columbiaa Hospital.",
      url: "https://www.youtube.com/embed/kaGGkTYp4yE"
    },
    {
      title: "Words of Appreciation by an Elderly Patient from West Bengal | Columbiaa Hospital",
      description: "An elderly patient from West Bengal shares heartfelt words of appreciation.",
      url: "https://www.youtube.com/embed/b3Ut2nkxAuE"
    },
    {
      title: "Praise from Patient's Attender | West Bengal | Dr. H. V. Satish Babu | Columbiaa Hospital",
      description: "A patient's attender from West Bengal shares heartfelt gratitude.",
      url: "https://www.youtube.com/embed/QxXD7kBqNdM"
    },
    {
      title: "Cancer Awareness Walkathon 2025",
      description: "Columbiaa Hospital Kasturi Nagar Bangalore organised a Cancer Awareness Walkathon.",
      url: "https://www.youtube.com/embed/9AQf0FkAvdE",
    },
    {
      title: "Raising Awareness, Saving Lives: World Cancer Day Walkathon & Screening Camp",
      description: "Glimpses of the world cancer day event organised by Columbiaa Hospital.",
      url: "https://www.youtube.com/embed/WR1E5JLhIqw",
    },
    {
      title: "Columbiaa Hospital Neuro Outreach Clinic - Bringing Expert Care Closer!",
      description: "Columbiaa Hospital, Bangalore conducts the Neuro Outreach Clinic at Medicare Hospital, Khotulpur.",
      url: "https://www.youtube.com/embed/PrweS9PceCI",
    },
    {
      title: "Columbiaa Hospital provides affordable surgical packages for all ailments.",
      description: "Columbiaa Hospital provides affordable surgical packages for all ailments.",
      url: "https://www.youtube.com/embed/dtzXsJpbbjM"
    },
    {
      title: "The Greatness of Women - Inspiring Speech by Our Beloved Doctor | Columbiaa Hospital",
      description: "On this special occasion of Women's Day, our esteemed doctor shares a heartfelt speech.",
      url: "https://www.youtube.com/embed/wRaEu-dbO_U",
    },
    {
      title: "Columbiaa Hospital's Neuro Health Camp | Dr. H.V. Satish Babu | CSR Outreach in West Bengal",
      description: "Columbiaa Hospital conducted its monthly Speciality Outreach Neuro Health Camp in West Bengal.",
      url: "https://www.youtube.com/embed/seVnudRXowo",
    },
    {
      title: "International Nurses Day 2025 Message from Dr. H V Satish Babu | Columbiaa Hospital",
      description: "On this International Nurses Day, Dr. H V Satish Babu extends his heartfelt appreciation.",
      url: "https://www.youtube.com/embed/-BUL3iP6lkQ",
    },
    {
      title: "Heartfelt Recovery - Sanjay Roy's journey under Dr. HV Satish Babu",
      description: "Sharing a heartfelt message from the attendant of Sanjay Roy.",
      url: "https://www.youtube.com/embed/ALIpoCfxFbM",
    },
    {
      title: "Nurses Day Celebration - Events, Games, and Prize Distribution | Columbiaa Hospital",
      description: "As part of our Nurses Day celebrations, we organised a series of exciting events.",
      url: "https://www.youtube.com/embed/MvYfT_00HoY",
    },
    {
      title: "Nurses Day Message from Dr. Arivazhagan, Senior Cardiologist - Columbiaa Hospital",
      description: "On this Nurses Day, Dr. Arivazhagan delivered an inspiring speech.",
      url: "https://www.youtube.com/embed/yfDPqafk9Dk",
    },
    {
      title: "Nurses Day Message from Dr. HV Satish Babu - Columbiaa Hospital",
      description: "Dr. HV Satish Babu shared an inspiring message appreciating the nursing team.",
      url: "https://www.youtube.com/embed/QISzy_UrcQQ",
    },
    {
      title: "Celebrating International Nurses Day 2025 - Columbiaa Hospital",
      description: "This International Nurses Day, we honour the strength, compassion, and unwavering dedication.",
      url: "https://www.youtube.com/embed/SmfdyAS13vg",
    },
    {
      title: "Free Bone Density Camp Highlights - Columbiaa Hospital, Kasturi Nagar",
      description: "A glimpse into our Free Bone Density Camp held at Columbiaa Hospital.",
      url: "https://www.youtube.com/embed/Oz9NWUy5sFc"
    },
    {
      title: "World Brain Tumor Day | Awareness by Dr. HV Satish Babu | Columbiaa Hospital",
      description: "On World Brain Tumor Day, Dr. HV Satish Babu shares vital insights.",
      url: "https://www.youtube.com/embed/lucU0LRAlVE"
    }
  ];

  const categories = [
    { key: 'msmeVisit', label: 'Glimpses of the MSME India Delegates\' Visit to Columbiaa Hospital, Kasturi Nagar', images: msmeVisitImages },
    { key: 'kmaVisit', label: 'Glimpses of the Karnataka Meitei Association (KMA) Team\'s Visit to Columbiaa Hospital, Kasturi Nagar', images: kmaVisitImages },
    { key: 'ariahAesthetics', label: 'Glimpses of Dr H V Satish Babu Participating in the Opening Ceremony of ARIAH Aesthetics, Bengaluru', images: ariahAestheticsImages },
     { key: 'womensDay', label: "Women's Day Celebrations", images: womensDayImages },
     { key: 'neurosurgeonAwards', label: 'Recognitions & Awards - Dr. H.V. Satish Babu', images: neurosurgeonAwardsImages },
     { key: 'top10Neurosurgeons', label: 'Glimpses of Dr H V Satish Babu Being Recognised Among the Top 10 Neurosurgeons in India – 2025 by Asia Business Outlook', images: top10NeurosurgeonsImages },
    { key: 'icuRounds', label: 'Glimpses of Dr H V Satish Babu, Neurosurgeon, During ICU Rounds – Assessing Patients and Guiding the Critical Care Team', images: icuRoundsImages },
    { key: 'purpleDay', label: 'Purple Day - Epilepsy Awareness', images: purpleDayImages },
    { key: 'collegeCamp', label: 'College Health Camps', images: collegeCampImages },
    { key: 'nuesesdayImages', label: "Nurses' Day Celebrations", images: nuesesdayImages },
    { key: 'doctorsDay', label: 'Glimpses of National Doctors\' Day Celebrations at Columbiaa Hospital, Kasturi Nagar', images: doctorsDayImages },
    { key: 'neuroOutreach', label: 'Glimpses of Neuro Outreach Camps Conducted in the Rural Areas of West Bengal by Columbiaa Hospital', images: neuroOutreachImages },
    { key: 'continuingNursingEducation', label: 'Glimpses of the Continuous Nursing Education Program for Excellence in Patient Care at Columbiaa Hospital, Kasturi Nagar', images: continuingNursingEducationImages },
    { key: 'healthCheckupImages', label: 'Health Checkup Camps', images: healthCheckupImages },
    { key: 'christmasCelebrations', label: 'Glimpses of Christmas Celebrations at Columbiaa Hospital, Kasturi Nagar', images: christmasCelebrationsImages },
    { key: 'rajeshYlVisit', label: 'Honoured to Welcome Rajesh Y L to Columbiaa Hospital, Kasturi Nagar, Deputy Superintendent of Police, Bengaluru', images: rajeshYlVisitImages },
  ];

  const images =
    currentGallery === "womensDay"
      ? womensDayImages
      : currentGallery === "neurosurgeonAwards"
      ? neurosurgeonAwardsImages
      : currentGallery === "msmeVisit"
      ? msmeVisitImages
      : currentGallery === "kmaVisit"
      ? kmaVisitImages
      : currentGallery === "ariahAesthetics"
      ? ariahAestheticsImages
      : currentGallery === "icuRounds"
      ? icuRoundsImages
      : currentGallery === "purpleDay"
      ? purpleDayImages
      : currentGallery === "collegeCamp"
      ? collegeCampImages
      : currentGallery === "nuesesdayImages"
      ? nuesesdayImages
      : currentGallery === "doctorsDay"
      ? doctorsDayImages
      : currentGallery === "neuroOutreach"
      ? neuroOutreachImages
      : currentGallery === "continuingNursingEducation"
      ? continuingNursingEducationImages
      : currentGallery === "top10Neurosurgeons"
      ? top10NeurosurgeonsImages
      : currentGallery === "christmasCelebrations"
      ? christmasCelebrationsImages
      : currentGallery === "rajeshYlVisit"
      ? rajeshYlVisitImages
      : healthCheckupImages;

  const closeModal = (e) => {
    if (e.target === e.currentTarget) {
      setSelectedImageIndex(null);
    }
  };

  return (
    <div className="container my-5">
      <Helmet>
        <title>Columbiaa Hospital Gallery | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Photos & Videos</title>
        <meta name="description" content="Explore Columbiaa Hospital photo gallery and videos showcasing our facilities, events, health camps, patient stories, and celebrations in Kasturi Nagar, Bangalore. View images of our advanced medical services, team events, Women's Day celebrations, Nurses Day, health checkup camps, and community outreach programmes." />
        <meta name="keywords" content="Columbiaa Hospital gallery, hospital photos, hospital videos, Columbiaa Hospital events, health camp photos, patient stories, healthcare gallery, Kasturi Nagar hospital gallery, Bangalore hospital photos, hospital events gallery, Women's Day celebration, Nurses Day celebration, health checkup camp, free health camp, community outreach, CSR activities, hospital facilities, medical camp photos, Columbiaa Hospital Bangalore, hospital photo gallery, hospital video gallery, best multi-speciality hospital Bangalore, hospital near me, top hospital Bangalore, healthcare events, patient appreciation, medical team events, Columbiaa Hospital Kasturi Nagar" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital Gallery | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Photos & Videos" />
        <meta property="og:description" content="Explore Columbiaa Hospital photo gallery and videos showcasing our facilities, events, health camps, patient stories, and celebrations in Kasturi Nagar, Bangalore." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/gallery" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/gallery" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>
      
      
      <h1 className="text-center mb-4" aria-label="Columbiaa Hospital Gallery and Videos">Gallery & Videos</h1>
      
      <div className="d-flex justify-content-center mb-4" role="tablist" aria-label="Gallery tabs">
        <button
          className={`btn mx-2 ${selectedTab === 'images' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setSelectedTab('images')}
          aria-pressed={selectedTab === 'images'}
          role="tab"
          aria-label="Show images tab"
        >
          Images
        </button>
        <button
          className={`btn mx-2 ${selectedTab === 'videos' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setSelectedTab('videos')}
          aria-pressed={selectedTab === 'videos'}
          role="tab"
          aria-label="Show videos tab"
        >
          Videos
        </button>
      </div>

      {selectedTab === 'videos' && (
        <div className="row" role="tabpanel" aria-label="Videos gallery">
          {videos.map((video, index) => (
            <div key={index} className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border border-primary rounded shadow" role="article" aria-label={`Video: ${video.title}`}>
                
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe
                    className="embed-responsive-item w-100"
                    src={video.url}
                    title={`Video: ${video.title}`}
                    allowFullScreen
                    loading="lazy"
                    aria-label={`YouTube video player for ${video.title}`}
                  ></iframe>
                </div>
                <div className="card-body">
                  <h5 className="card-title" aria-label={`Video title: ${video.title}`}>{video.title}</h5>
                  <p className="card-text small" aria-label={`Video description: ${video.description}`}>{video.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedTab === 'images' && (
        <div>
          {categories.map((cat) => (
            <div key={cat.key} className="mb-5">
              <h2 className="mb-4" style={{ color: "#04d3bc", fontSize: "32px", fontWeight: "600" }}>
                {cat.label}
              </h2>
              <div className="row" role="list" aria-label={`${cat.label} gallery`}>
                {cat.images.map((img, index) => (
                  <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4" role="listitem">
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="img-fluid rounded shadow cursor-pointer"
                      onClick={() => {
                        setCurrentGallery(cat.key);
                        setSelectedImageIndex(index);
                      }}
                      loading="lazy"
                      aria-label={`View larger image: ${img.alt}`}
                      style={{ cursor: 'pointer', height: '200px', objectFit: 'cover' }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedImageIndex !== null && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
          onClick={closeModal}
          aria-modal="true"
          role="dialog"
          aria-label="Image preview modal"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={() => setSelectedImageIndex(null)}
                  aria-label="Close"
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body text-center">
                <img
                  src={images[selectedImageIndex].src}
                  alt={images[selectedImageIndex].alt}
                  className="img-fluid"
                  aria-label={`Full size image: ${images[selectedImageIndex].alt}`}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGalleryStatic;
